module.exports = __webpack_public_path__ + "img/play-and-win-retro-text.72e54ab0.png";